import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { Link } from 'react-router-dom';

import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbDown from '@material-ui/icons/ThumbDown';

const CheckoutCompletedView = ({ email, onOpenFeedbackClick, orderId }) => {
  return (
    <div className="checkout-success">
      <h3>
        <FormattedMessageWrappedInSpan
          id="checkoutCompletedView.thankyou"
          defaultMessage="Thank You!"
        />
      </h3>
      <FormattedMessageWrappedInSpan
        id="checkoutCompletedView.message.line1"
        defaultMessage="Thank you for your order. We have just sent you a confirmation email to"
      />
      <span className="checkout-success-email">{email}</span>
      <FormattedMessageWrappedInSpan
        id="checkoutCompletedView.message.line2"
        defaultMessage="Please check your spam as well.{br}Enjoy your photos!"
        values={{ br: <br /> }}
      />
      <h4 className="center-text">
        <FormattedMessageWrappedInSpan
          id="checkoutCompletedView.orderId"
          defaultMessage="Order ID: {orderId}"
          values={{
            orderId: orderId,
          }}
        />
      </h4>
      <div className="checkout-success-feedback-container mb-50" onClick={onOpenFeedbackClick}>
        <p>
          <ThumbUp color="primary" />
          <ThumbDown color="primary" />
        </p>
        <FormattedMessageWrappedInSpan
          id="checkoutCompletedView.openFeedbackButton"
          defaultMessage="Give us feedback"
        />
      </div>
      <Link to="/">
        <FormattedMessageWrappedInSpan
          id="checkoutCompletedView.linkToHomePage"
          defaultMessage="Continue browsing"
        />
      </Link>
    </div>
  );
};

export { CheckoutCompletedView };

CheckoutCompletedView.propTypes = {
  email: PropTypes.string,
  onOpenFeedbackClick: PropTypes.func,
  orderId: PropTypes.string,
};

export default CheckoutCompletedView;
